document.addEventListener('DOMContentLoaded', function () {
    const slider = $('.js-trading-slider');

    const initTradingTools = () => {
        const INITIAL_SLIDE = 0;
        const DESKTOP_SIZE = 1200;
        let currentSlideIndex = INITIAL_SLIDE;
        const switcher = document.querySelector('.js-toggle-slide-tools');
        const arrow = document.querySelector('.js-tool-arrow');
        const tabs = Array.from(switcher.children);


        slider.slick({
            mobileFirst: true,
            dots: true,
            centerMode: true,
            variableWidth: true,
            infinite: false,
            initialSlide: INITIAL_SLIDE,
            arrows: false,
            dotsClass: 'tools__dots',
            appendDots: $('.tools__col_has-shadow'),
            rtl: m.about.rtl,
            responsive: [{
                breakpoint: DESKTOP_SIZE - 1,
                settings: {
                    autoplay: true,
                    autoplaySpeed: 5000,
                    variableWidth: false,
                    dots: false,
                    centerMode: false,
                    infinite: false,
                    fade: true,
                }
            }]
        });

        slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            arrow.style.transform = `translateY(${tabs[nextSlide].offsetTop}px)`;
            currentSlideIndex = currentSlide;
            tabs[currentSlide].classList.remove('is-active');
            tabs[nextSlide].classList.add('is-active');
            slider.slick('slickSetOption', 'autoplay', false);
        });

        // initialize switcher by current slide
        tabs[currentSlideIndex].classList.add('is-active');
        const startPosition = tabs[currentSlideIndex].offsetTop;
        arrow.style.transform = `translateY(${startPosition}px)`;

        switcher.addEventListener('click', ({target}) => {
            const targetElement = target.closest('.tools__item');
            const nextSlideIndex = tabs.findIndex(it => it === targetElement);

            if (!target) return false;
            slider.slick('slickGoTo', nextSlideIndex);
        });

        const setArrowPosition = () => {
            const isDesktop = window.matchMedia(`(min-width: ${DESKTOP_SIZE}px)`).matches;
            if (isDesktop) arrow.style.transform = `translateY(${tabs[currentSlideIndex].offsetTop}px)`;
        };

        window.addEventListener('resize', setArrowPosition);
    };

    slider && initTradingTools();
});